"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextNMRHint = void 0;
const getNMRHints_js_1 = require("./getNMRHints.js");
/**
 *
 * @param {import('openchemlib').Molecule} correct
 * @param {import('openchemlib').Molecule} proposed
 * @param {Array} providedHints
 */
function getNextNMRHint(correct, proposed, providedHints) {
    const hints = (0, getNMRHints_js_1.getNMRHints)(correct, proposed);
    const possibleHints = hints.filter((possibleHint) => !providedHints.some((providedHint) => possibleHint.hash === providedHint.hash));
    if (possibleHints.length === 0)
        return undefined;
    return {
        ...possibleHints[0],
        idCode: proposed.getIDCode(),
    };
}
exports.getNextNMRHint = getNextNMRHint;
//# sourceMappingURL=getNextNMRHint.js.map